import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const closeSvg =
  '<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="1.49613" y1="0.788536" x2="29.7804" y2="29.0728" stroke="currentColor"></line><line x1="0.646447" y1="28.9306" x2="28.9307" y2="0.646356" stroke="currentColor"></line></svg>';
const arrowPrevSvg =
  '<svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 1L0.999999 15L15 29" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"></path></svg>';
const arrowNextSvg =
  '<svg width="16" height="30" viewBox="0 0 16 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.999998 29L15 15L0.999999 0.999999" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"></path></svg>';

function setGallery(gallery) {
  const grid = gallery.querySelector('.js-gallery__grid');
  const terms = gallery.querySelectorAll('.gallery__term');

  if (grid) {
    imagesLoaded(grid, () => {
      const iso = new Isotope(grid, {
        itemSelector: '.js-gallery__grid-item',
        layoutMode: 'masonry',
        transitionDuration: '0.4s',
        filter: terms.length ? `.${terms[0].dataset.galleryTerm}` : '*',
      });

      terms.forEach((term) => {
        term.addEventListener('click', () => {
          terms.forEach((t) => t.classList.remove('is-active'));
          term.classList.add('is-active');
          iso.arrange({ filter: `.${term.dataset.galleryTerm}` });
        });
      });
    });
  }

  const lightbox = new PhotoSwipeLightbox({
    gallery,
    children: '.gallery__wrapper-item-image',
    bgOpacity: 1,
    showHideOpacity: true,
    zoom: false,
    counter: false,
    arrowPrevSVG: arrowPrevSvg,
    arrowNextSVG: arrowNextSvg,
    closeSVG: closeSvg,
    pswpModule: () => import('photoswipe'),
  });

  lightbox.addFilter('itemData', (itemData) => {
    itemData.caption = itemData.element?.dataset.pswpCaption || '';
    return itemData;
  });

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'caption',
      order: 9,
      isButton: false,
      appendTo: 'root',
      html: '',
      onInit: (el, pswp) => {
        pswp.on('change', () => {
          const caption = pswp.currSlide?.data?.caption;
          el.innerHTML = caption ? `<div class="pswp__caption__center">${caption}</div>` : '';
        });
      },
    });
  });

  lightbox.init();
}

document.querySelectorAll('.js-gallery').forEach(setGallery);
